import { atom } from 'recoil';
import { INivelFluenciaConfig } from '../../commons/types/crm';


export const configNivelFluenciasAtom = atom<INivelFluenciaConfig[]>({
  key: 'configNivelFluencias', 
  default: [] as INivelFluenciaConfig[],
}); 
